// import logo from '../../../assets/svg/logo.svg';
// import brandName from '../../../assets/svg/brand-name.svg';
import { useEffect, useState } from 'react';
// import { useHistory } from 'react-router';
import Button from '../common/Button';
import lighting from '../../../assets/svg/lighten-white.svg'
import Share from '../../../assets/svg/share.svg'
import Exclamation from '../../../assets/svg/exclamation.svg'
import Verified from '../../../assets/svg/verified.svg'
// import QrCode from '../../../assets/images/qrcode.png'
import { initialize, registerActivity } from '../../../services/widget';
import { verifyBank } from '../../../services/bank';
import { checkStatus } from '../../../services/transaction';
import Typer from '../common/Typer';

function Sell(props) {

    const [page, setPage] = useState(props.page) //sell or track
    const [step, setStep] = useState(1)
    const [stepVerify, setStepVerify] = useState(1)
    const [trackingID, setTrackingID] = useState(null)
    const [payload, setPayload] = useState({})
    const [tranxDetail, setTranxDetail] = useState({})
    const [tranxStatus, setTranxStatus] = useState({})
    const [errors, setErrors] = useState({})
    const [account, setAccount] = useState(null)
    const [loading, setLoading] = useState(false)
    // const history = useHistory()

    const copy = () => {
        const textToPutOnClipboard = document.getElementById('btc-address').innerHTML;
        const elem = document.createElement('textarea');
        elem.value = textToPutOnClipboard;
        document.body.appendChild(elem);
        elem.select();
        document.execCommand('copy');
        document.body.removeChild(elem);
        alert("link copied to clipboard")
    }
    
    const updateTrackingID = e => {
        const t = e.target.value;
        setTrackingID(t)
        if( t.length >= 6 ) {
            setLoading( true )
            checkStatus(t).then( res => {
                setTranxStatus( res.data.data )
                setStepVerify(2)
            }).catch( err => {
                setErrors({
                    ...errors,
                    trackingID: err.message
                })
            }).finally( () => {
                setLoading( false )
            })
            // 
        }
    }

    useEffect( () => {
        setPage(props.page)
    }, [props.page])

    const sendRegisterActivity = ( data = null ) => {
        
        const payload = { type: "transactionInitiated", frameId: "PLCzE", host: window.location.host }
        
        if ( data !== null ) {
            payload.transactionData = data
        }

        registerActivity(payload).then( res => {
            console.log(res)
        })
    }

    useEffect( () => {
        sendRegisterActivity(null)
    }, [])

    const banks = [
        {
            "code": "044",
            "name": "Access Bank"
        },
        {
            "code": "023",
            "name": "Citi Bank"
        },
        {
            "code": "050",
            "name": "EcoBank PLC"
        },
        {
            "code": "011",
            "name": "First Bank PLC"
        },
        {
            "code": "214",
            "name": "First City Monument Bank"
        },
        {
            "code": "070",
            "name": "Fidelity Bank"
        },
        {
            "code": "058",
            "name": "Guaranty Trust Bank"
        },
        {
            "code": "076",
            "name": "Polaris bank"
        },
        {
            "code": "221",
            "name": "Stanbic IBTC Bank"
        },
        {
            "code": "068",
            "name": "Standard Chaterted bank PLC"
        },
        {
            "code": "232",
            "name": "Sterling Bank PLC"
        },
        {
            "code": "033",
            "name": "United Bank for Africa"
        },
        {
            "code": "032",
            "name": "Union Bank PLC"
        },
        {
            "code": "035",
            "name": "Wema Bank PLC"
        },
        {
            "code": "057",
            "name": "Zenith bank PLC"
        },
        {
            "code": "215",
            "name": "Unity Bank PLC"
        },
        {
            "code": "101",
            "name": "ProvidusBank PLC"
        },
        {
            "code": "082",
            "name": "Keystone Bank"
        },
        {
            "code": "301",
            "name": "Jaiz Bank"
        },
        {
            "code": "030",
            "name": "Heritage Bank"
        },
        {
            "code": "100",
            "name": "Suntrust Bank"
        },
        {
            "code": "608",
            "name": "FINATRUST MICROFINANCE BANK"
        },
        {
            "code": "090175",
            "name": "Highstreet Microfinance Bank"
        },
        {
            "code": "090267",
            "name": "Kuda"
        },
        {
            "code": "90115",
            "name": "TCF MFB"
        },
        {
            "code": "400001",
            "name": "FSDH Merchant Bank"
        },
        {
            "code": "502",
            "name": "Rand merchant Bank"
        },
        {
            "code": "784",
            "name": "Globus Bank"
        }
    ]

    const handleBank = e => {
        const value = e.target.value;
        const bank = banks.find( b => b.code == value )
        setPayload({
            ...payload,
            bankCode: bank.code,
            bankName: bank.name
        })
    }

    const onChange = e => {
        const name = e.target.name
        const value = e.target.value
        setPayload({...payload, [name]: value})

        if (name === "accountNumber" && value.length === 10) {
            if ( !payload.bankCode ) {
                const e = {target: {value: "044"}}
                handleBank( e )
            }
            const data = {
                accountNumber: value,
                bankCode: payload.bankCode || "044"
            }
            setErrors({...errors, account_name: ""})
            setLoading(true)
            verifyBank(data).then( res => {
                setAccount(res.data.data)
            }).catch( err => {
                // console.log(err)
                setErrors({...errors, account_name: err.message})
            }).finally( () => {
                setLoading(false)
            })
        }
    }

    const merchant = JSON.parse( window.localStorage.getItem("bMerchant") || "[]") || []

    const handleProceed = () => {

        // window.localStorage.removeItem("tranxDetails")

        setErrors({})

        if ( !account.accountname ) {
            setErrors({
                ...errors,
                account_name: "account name is required"
            })
        }

        if ( merchant.length <= 0 ) {

        }

        const needed = ["email", "phone"]

        let valid = true

        needed.forEach( n => {
            console.log(payload[n])
            if ( !payload[n] ) {
                valid = false
                setErrors({
                    ...errors,
                    [n]: n + " is required"
                })
            }
        })

        if ( !valid ) {
            return false;
        }

        const data = payload
        data.accountName = account.accountname
        data.accountNumber = data.accountNumber || account.accountnumber
        data.merchant = merchant

        setLoading(false)

        initialize(data).then( res => {
            const data = res.data.data
            // window.localStorage.setItem("tranxDetails", JSON.stringify(data) )
            setTranxDetail(data)
            sendRegisterActivity( data )
            setStep(2)
        }).finally( () => {
            setLoading(false)
        })
    }

    return (
        <div className={`Sell flex justify-center items-center md:w-full lg:w-1/3 px-16 py-6 bottom-0 top-0 fixed ${props.className}`} style={{zIndex: "200"}}>
            <div className="flex flex-col">
                {/* <div className={`close-menu ${show ? '': 'mobile-hidden'}`}></div> */}

                <div className={` ${page === "track" ? "" : "hidden"} relative`} >
                    <div className="text-brown-dark relative" className={`text-brown-dark relative flex items-center ${stepVerify === 1 ? "-mt-28 mb-32": "-mt-12 mb-12"} `}>
                        <spnan>
                            {
                                stepVerify === 1 ? 
                                ""
                                :
                                <span className="text-3xl absolute top-0 left-0 p-0 cursor-pointer" style={{zIndex: "3000"}} onClick={() => setStepVerify(1)}>&#8592;</span>
                            }
                        </spnan>
                        <span className="text-3xl absolute top-0 right-0 p-0 cursor-pointer" style={{zIndex: "3000"}} onClick={ props.onClose }>&times;</span>
                    </div>
                    <div className="my-8">
                        <span className="text-xs text-brown-dark text-sm" style={{fontWeight: "500"}}>Step { stepVerify } of 2</span>
                        <div className="w-full h-2 mt-3 rounded-full bg-yellow bg-opacity-25">
                            <div className={`w-${stepVerify}/2 h-2 ${stepVerify !== 2 ? 'bg-yellow': 'bg-green'} rounded-full`}></div>
                        </div>
                    </div>

                    <div className={`${stepVerify === 1 ? '' : 'hidden'}`}> 
                        <h2 className="text-3xl font-bold text-brown-dark">Track your transaction</h2>
                        <span className="my-3 text-brown-dark text-sm">Get update on pending or lastest transaction after initiating a transaction.</span>
                        <div className="mt-3 relative">
                            <label className="block text-sm text-brown-dark">Tracking ID</label>
                            <input type="text" placeholder="7W5H12" onChange={ (e) => updateTrackingID(e) } className="border-2 w-full py-2 px-4 mt-1 rounded-md focus:border-brown text-brown-dark outline-none text-bold" />
                            <div className="absolute flex justify-between top-0 right-0 mt-10 mr-4">
                                { 
                                    loading ? 
                                    <div className="loader"></div> :
                                    Object.values(tranxStatus?.widget || {}).length > 0 ? <img src={Verified} alt="z" width="20px"/> : ""
                                }
                            </div>
                            <font size="1" color="red">{ errors.trackingID }</font>
                        </div>
                    </div>

                    <div className={`${stepVerify === 2 ? '' : 'hidden'}`}> 
                        <h3 className="text-2xl font-bold text-brown-dark">Transaction Pending</h3>
                        <span className="my-4 text-brown-dark text-sm">
                            Your payment to our bitcoin address is yet to be verified. Please contact support.
                        </span>

                        <div className="px-8 py-5 mt-6 flex flex-col justify-center items-center rounded-lg" style={{background:"rgba(231, 208, 131, 0.1)"}}>
                            <h4 className="text-sm">BTC ADDRESS</h4>
                            <span id="btc-address" className="font-bold text-sm">{ tranxStatus?.widget?.address }</span>

                            <h4 className="mt-2 text-sm">Tracking ID</h4>
                            <span className="font-bold text-sm">{ trackingID }</span>

                            <div className="flex flex-row justify-center my-2 w-full">
                                
                                <div className="w-2/3 p-4 flex flex-col items-center text-brown-dark text-sm m-1 rounded-md" style={{background: "rgba(239, 167, 11, 0.1)"}}>
                                    <span className="text-center">{ tranxStatus?.widget?.bankName }</span>
                                    <span className="text-center">{ tranxStatus?.widget?.accountNumber }</span>
                                    <span className="text-center">{ tranxStatus?.widget?.accountName }</span>
                                </div>
                                <div className="w-1/3 flex flex-col items-center justify-center m-2 rounded-md" style={{background: "rgba(239, 167, 11, 0.1)"}}>
                                    <span className="text-xs">Status</span>
                                    <span className={`${ tranxStatus?.deposits ? "text-green": "text-red"}`}>{ tranxStatus?.deposits ? "Successful" : "Pending" }</span>
                                </div>
                            </div>

                            <div className="my-3">
                                <img src={ tranxStatus?.deposits ? Verified : Exclamation} alt="!" width="20px"/>
                            </div>

                            <div className={`text-sm ${ tranxStatus?.deposits ? "text-green": "text-red"} my-2 text-center`}>
                                {
                                    tranxStatus?.deposits ?
                                    "We have received your bitcoin payment with " + tranxStatus?.deposits?.confirmation  + ( tranxStatus?.deposits?.confirmation === 1 ? " confirmation" : " confirmations")
                                    :
                                    "We’re yet to receive you bitcoin payment"
                                }
                            </div>
                            <div className="text-sm text-gray-500 my-2 text-center">
                                Contact bitcoinaboki@Support.com or call { merchant.phone_number } for support
                            </div>
                        </div>
                    </div>
                </div>
                

                <div className={` ${page === "sell" ? "" : "hidden"} relative ${step === 1 ? "-mt-32": ""} `} >
                    <div className={`text-brown-dark relative flex items-center ${step === 1 ? "-mt-28 mb-32": "-mt-12 mb-12"} `}>
                        <spnan style={{fontWeight: "500"}}>
                            {
                                step === 1 ? 
                                <Typer
                                // heading={'No '}
                                dataText={["No Sign Up Required","No Payment Delay","No Download or OTP Required"]} 
                                className="mt-2"
                                />
                                :
                                <span className="text-3xl absolute top-0 left-0 p-0 -mt-4 cursor-pointer" onClick={() => setStep(1)}>&#8592;</span>
                            }
                        </spnan>
                        <span className="text-2xl absolute top-0 right-0 p-0 mt-2 cursor-pointer font-thin h-6 w-6 bg-gray-400 rounded-full flex items-center justify-center" onClick={ props.onClose }>&times;</span>
                    </div>
                    
                    <div className={`${step === 1 ? "-my-12": "my-5"} `}>
                        <div >
                            <span className="text-xs text-brown-dark text-sm" style={{fontWeight: "500"}}>Step { step } of 2</span>
                            <div className="w-full h-2 mt-3 rounded-full bg-yellow bg-opacity-25">
                                <div className={`w-${step}/2 h-2 ${step !== 2 ? 'bg-yellow': 'bg-green'} rounded-full`}></div>
                            </div>
                        </div>

                        <div className={`${step === 1 ? '' : 'hidden'}`}> 
                            <h2 className="text-2xl font-bold text-brown-dark">Provide Transaction Detail</h2>
                            <span className="my-3 text-brown-dark font-bold text-sm">We no dey waste time. You go get alert sharp sharp.</span>

                            <div className="mt-3">
                                <label className="block text-sm text-brown-dark">Select Bank</label>
                                <select className="border-2 w-full py-2 px-4 mt-1 rounded-md focus:border-brown text-brown-dark outline-none text-bold" onChange={handleBank}>
                                    {
                                        banks.map( ( bank, i ) => <option value={bank.code}>{bank.name}</option>)
                                    }
                                </select>
                            </div>
                            <div className="mt-3 relative">
                                <label className="block text-sm text-brown-dark">Account Number</label>
                                <input 
                                    type="number" 
                                    pattern={'\d*'} 
                                    onChange={onChange} 
                                    minLength="10" 
                                    maxLength="10" 
                                    max="10" 
                                    required 
                                    placeholder="0123...." 
                                    name="accountNumber" 
                                    className="border-2 w-full py-2 px-4 mt-1 rounded-md focus:border-brown text-brown-dark outline-none text-bold" 
                                />
                                <div className="absolute flex justify-between top-0 right-0 mt-10 w-3/5 mr-4">
                                    <font size="1" className={`text-gray-600 ${account ? "": "hidden"}`}>({ account?.accountname })</font>
                                    { 
                                        loading ? 
                                        <><>.</><div className="loader float-right"></div></> :
                                        account ? <img src={Verified} alt="z" width="20px"/> : ""
                                    }
                                </div>
                                <font size="1" color="red">{ errors.account_name }</font>
                            </div>
                            <div className={`${account ? "": "hidden"}`}>
                                <div className="mt-3">
                                    <label className="block text-sm text-brown-dark">Email Address</label>
                                    <input type="text" placeholder="you@email.com" required onChange={onChange} name="email" className="border-2 w-full py-2 px-4 mt-1 rounded-md focus:border-brown text-brown-dark outline-none text-bold" />
                                    <font size="1" color="red">{ errors.email }</font>
                                </div>
                                <div className="mt-3">
                                    <label className="block text-sm text-brown-dark">Phone</label>
                                    <input type="text" placeholder="+23480123..." required onChange={onChange} name="phone" className="border-2 w-full py-2 px-4 mt-1 rounded-md focus:border-brown text-brown-dark outline-none text-bold" />
                                    <font size="1" color="red">{ errors.phone }</font>
                                </div>

                                <small className="text-gray-700 text-xs">
                                By clicking on “Continue” you agree to our Terms of Service and Privacy Policy.
                                </small>
                            </div>
                            
                            <div className="flex justify-center items-center mt-4">
                                <Button 
                                    onClick={ () => handleProceed()} 
                                    className="text-white border-0 bg-brown-dark flex items-center m-4 text-xs px-8 py-3 rounded-md font-bold"
                                    disabled={!account || loading}
                                >
                                    {
                                        loading ? 
                                        <div className="loader"></div>
                                        :
                                        <><img src={lighting} alt="z" width="7px"/> &nbsp; Submit</>
                                    }
                                </Button>
                            </div>
                        </div>
                    </div>

                    <div className={`${step === 2 ? '' : 'hidden'}`}> 
                        <h3 className="text-2xl font-bold text-brown-dark">Send Bitcoin To Your Wallet</h3>
                        <span className="my-4 text-brown-dark text-xs">Make payment to the bitcoin address or scan barcode below, also check { payload.email } for these information</span>

                        <div className="px-8 py-5 mt-6 flex flex-col justify-center items-center rounded-lg" style={{background:"rgba(231, 208, 131, 0.1)"}}>
                            <h4 className="text-sm text-brown-dark">BTC ADDRESS</h4>
                            <span id="btc-address" className="font-bold text-xs">{ tranxDetail.address }</span>

                            <h4 className="mt-2 text-sm">Tracking ID</h4>
                            <span className="font-bold text-sm">{ tranxDetail.transaction_reference }</span>

                            <div className="flex flex-row justify-center my-2">
                                <div className="w-1/2">
                                    {/* <img src={QrCode} alt="hsd7s78sus89s9shdd876533gdnvxx" /> */}
                                    <img width="200px" src={`https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl=${tranxDetail.address}`} alt={tranxDetail.address}/>
                                </div>
                                <div className="w-1/2 p-4 flex flex-col items-center text-brown-dark text-sm rounded-md" style={{background: "rgba(239, 167, 11, 0.1)"}}>
                                    <span className="text-center">{ payload?.bankName }</span>
                                    <span className="text-center">{ payload?.accountNumber }</span>
                                    <span className="text-center">{ account?.accountname }</span>
                                </div>
                            </div>

                            <div className="text-xs text-gray-500 my-2 text-center">
                                The above bank account will be credited after Bitcoin has been confirmed
                            </div>
                            <div className="text-xs text-brown-dark my-2 text-center">
                                <span className="text-blue-lighter cursor-pointer" onClick={ () => setPage("track")}>Click here</span> to track this transaction
                            </div>
                            <div className="text-xs text-gray-500 my-2 text-center">
                                bitcoinaboki@support.com <br/>{ merchant.phone_number }
                            </div>
                        </div>

                        <div className="flex justify-center items-center mt-4">
                            <Button 
                                onClick={ () => copy()} 
                                className="text-white border-0 bg-brown-dark flex items-center m-4"
                            >
                                Copy Wallet Address
                            </Button>

                            <a href={`whatsapp://send?text=${tranxDetail.address}`} data-action="share/whatsapp/share" className="text-white border-0 bg-blue-lighter flex items-center m-4 py-2 px-4 rounded-md">
                                <img src={Share} alt="z" width="20px"/>
                            </a>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
  }
  
  export default Sell;
  
  //DHAFCH